module.exports = __webpack_public_path__ + "img/winDefalutButton.0e604388.png";